module.exports = {
  ...require('./valkur'),
  ...require('./vergadain'),
  ...require('./vhaeraun'),
}
